<template>
    <div id="step3">
        <div v-if="Object.keys(addons).length > 0">
            <HeadFoot title="Add Ons" v-on:back="back()" v-on:clicked="next()" button="Next"></HeadFoot>

            <h5 class="text-center mt-3" v-if="numSteps === 4">Customize your package with these additional products!</h5>

            <div class="flex flex-wrap items-top justify-around mt-4">
                <div
                    class="relative flex flex-col justify-end text-center mb-8 border border-leonard-grey rounded-md overflow-hidden"
                    style="width:300px;"
                    v-for="({flyername, descript, net_price, pose_select_req, pkg_no, conttype, pose_limit}, i) in addons"
                    :key="i"
                >
                    <div class="addon" :class="'addon-'+slug(pkg_no)+'O'" v-if="conttype == 'OUTSOURCE'"></div>
                    <div class="addon" :class="'addon-'+slug(pkg_no)" v-else></div>
                    <div class="relative">
                        <div class="p-1 mb-2">
                            <div class="text-lg">{{flyername}}</div>
                            <p class="text-leonard-white italic text-sm" v-if="descript">{{descript}}</p>
                            <p><strong>${{net_price.toFixed(2)}}</strong></p>
                        </div>
                        <button
                            v-if="pose_select_req && parseInt(pose_limit) < 99"
                            type="button"
                            class="font-medium transition-all duration-300 border-2 block w-full py-2 px-3 md:px-4 bg-leonard-black border-leonard-black text-leonard-white hover:bg-leonard-black-hover hover:border-transparent cursor-pointer"
                            @click="select(pkg_no)"
                        >
                            Select
                        </button>
                        <button
                            v-if="!pose_select_req || parseInt(pose_limit) >= 99"
                            type="button"
                            class="font-medium transition-all duration-300 border-2 block w-full py-2 px-3 md:px-4 bg-leonard-green border-leonard-green text-leonard-white hover:bg-leonard-green-hover hover:border-transparent cursor-pointer"
                            @click="addToCart(addons[i])"
                        >
                            Add
                            <font-awesome-icon icon="cart-plus"></font-awesome-icon>
                        </button>
                    </div>
                </div>
            </div>

            <HeadFoot v-on:back="back()" v-on:clicked="next()" button="Next"></HeadFoot>
        </div>

        <div class="data-loading text-center mt-5" v-else>
            <font-awesome-icon fixed-width icon="spinner" size="3x" pulse v-if="!error"></font-awesome-icon>
            <div v-else>{{error}}</div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {faCartPlus, faSpinner } from '@fortawesome/free-solid-svg-icons'

import Package from '../../classes/Package'
import Order from '../../classes/Order'
import Cart from '../../classes/Cart'

import HeadFoot from '../ordersteps/partials/StepHeaderFooter'

export default {
    props: ['studentid', 'numSteps'],

    data() {
        return {
            Package: new Package(),
            Order: new Order(),
            Cart: new Cart(),
            access_code: localStorage.getItem('access_code'),
            con_no: localStorage.getItem('con_no'),
            school: localStorage.getItem('school'),
            addons: {},
            error: null,
        }
    },

    components: {
        HeadFoot,
    },

    created() {
        library.add(faSpinner, faCartPlus)

        if (this.access_code != null && this.con_no != null) {
            this.getAddons()
        } else {
            let alert = {
                show: true,
                level: 'danger',
                text: 'No access code was found',
            }

            this.$emit('alertStatus', alert)
            this.$router.push({ params: { step: null } })
        }
    },

    mounted() {
        window.events.$emit('updateProgress')
        document.title = 'Add Ons - ' + document.title
    },

    methods: {
        getAddons() {
            let self = this
            let data = {
                con_no: this.con_no,
            }

            this.Package.getAddons(data)
                .then(function (response) {
                    window.events.$emit('finishedLoading')
                    if(typeof response.data === 'object' && response.data !== null && Object.keys(response.data).length > 0) {
                        self.addons = response.data
                    } else {
                        self.error = "No products were found. Please contact customer service."
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        },

        addToCart(addon) {
            let self = this
            let data = {
                user_id: this.$auth.user().details.id,
                name: addon.flyername,
                con_no: this.con_no,
                school: this.school,
                accesscode: this.access_code,
                price: addon.net_price,
                tax_amt: addon.tax_amt,
                extra_poses: 0,
                package_number: addon.pkg_no,
                contents: addon.contents.map(function (a) {
                    return {
                        name: a.name,
                        poses: [],
                        download: a.download,
                        rush: 0,
                    }
                }),
                freebies: [],
            }

            this.Cart.addItem(data, data.user_id)
                .then(function (response) {
                    window.events.$emit('addToCart')
                    feedback('Package successfully added to cart')
                    // self.next();
                })
                .catch(function (error) {
                    console.error(error)
                })
        },

        async checkCartForRetouching() {
            let self = this

            return await this.Cart.checkRetouching(self.$auth.user().details.id)
        },

        select(pkg_no) {
            this.$router.push({ params: { step: 'addons', package: pkg_no } })
        },

        slug(str) {
            return str.split(' ').join('-')
        },

        next() {
            let self = this
            this.checkCartForRetouching().then(function (response) {
                if (!response.data) {
                    feedback(
                        'An error occurred checking the cart for retouching options.',
                        'danger'
                    )
                    return
                }

                if (response.data.all === 0) {
                    self.$router.push({
                        params: { step: 'addons', package: 'retouching' },
                    })
                    return
                }

                self.$emit('nextStep')
            })
        },

        back() {
            this.$emit('back', 'packages')
        },
    },
}
</script>

<style lang="scss" scoped>
.addon {
    background-image: url('/images/Master.png');
    width: 100%;
    max-width: 300px;
    height: 250px;
    background-size: 2100px;

    &.addon-017O, &.addon-008 {
        // 20x24 Gallery Wrap
        background-position: 1200px 560px;
    }

    &.addon-018O, &.addon-009 {
        // 16x20 Gallery Wrap
        background-position: 1480px 560px;
    }

    &.addon-078O, &.addon-077 {
        // 11x14 Gallery Wrap
        background-position: 585px 1115px;
    }

    &.addon-001,
    &.addon-010 {
        // 20x24
        background-position: 305px 555px;
    }

    &.addon-002,
    &.addon-011 {
        // 16x20
        background-position: 325px 1110px;
    }

    &.addon-003,
    &.addon-012 {
        // 11x14
        background-position: 2090px 1110px;
    }

    &.addon-004,
    &.addon-013,
    &.addon-036 {
        // 8x10
        background-position: 1790px 1085px;
    }

    &.addon-005,
    &.addon-014,
    &.addon-037 {
        // 5x7
        background-position: 1508px 1100px;
    }

    &.addon-006,
    &.addon-015,
    &.addon-038 {
        // 4x5
        background-position: 1180px 1100px;
    }

    &.addon-007,
    &.addon-016,
    &.addon-039 {
        // Wallet
        background-position: 900px 1100px;
    }

    &.addon-020 {
        // Preview Book
        background-size: 2400px;
        background-position: 980px 645px;
    }

    &.addon-018 {
        // Standard Portfolio & Previews
        background-position: 585px 850px;
    }

    &.addon-021 {
        // DVD Slideshow
        background-size: 2800px;
        background-position: 725px 700px;
    }

    &.addon-C01,
    &.addon-C02 {
        // The Composite
        background-position: 2095px 830px;
    }

    &.addon-C03,
    &.addon-C04 {
        // The Collection
        background-position: 1506px 840px;
    }

    &.addon-C05,
    &.addon-C06 {
        // The Charmed
        background-position: 1190px 840px;
    }

    &.addon-C07,
    &.addon-C08 {
        // The Vestige
        background-position: 1796px 830px;
    }

    &.addon-C09,
    &.addon-C10 {
        // The Journey
        background-position: 910px 840px;
    }

    &.addon-I07,
    &.addon-022,
    &.addon-023 {
        // Hi-Res Download
        background-position: 898px 295px;
    }

    &.addon-P03 {
        // Elite Portfolio
        background-position: 300px 850px;
    }

    &.addon-P04 {
        // Custom Portfolio
        background-position: 2100px 580px;
    }

    &.addon-P05 {
        // Standard Portfolio
        background-position: 1795px 580px;
    }

    &.addon-A05 {
        // Pasco Package E
        background-position: 900px 265px;
    }

    &.addon-A06 {
        // Pasco Package F
        background-position: 900px 265px;
    }

    &.addon-A07 {
        // Pasco Package G
        background-position: 900px 265px;
    }
}
</style>
